import React from "react";
import { EMOJI_CATEGORIES_I18N_KEYS, EMOJI_CATEGORIES_ICON_KEYS } from "../../../../constants/components/emoji";
import { CButton } from "../../../UI";
import { useLocaleContext } from "../../../../context/LocaleContext";

import "./style.scss";

const EmojiCategoryItem = ({ category, activeCategory, onClick }) => {
    const { get } = useLocaleContext();

    return (
        <li
            data-category={category}
            title={get(`emoji.${EMOJI_CATEGORIES_I18N_KEYS[category]}`)}
            className={`emoji-picker-category-item ${category === activeCategory ? 'active' : ''}`}
        >
            <CButton
                blank
                icon={EMOJI_CATEGORIES_ICON_KEYS[category]}
                onClick={() => onClick(category)}
            />
        </li>
    );
};

export default EmojiCategoryItem;
